import { Box, Typography } from "@mui/material";
import React from "react";

export default function CardImageSignin({ image, text, title, value,...props }) {
  const styleScrollTab = {
    width: "37px",
    height: "8px",
    borderRadius: "19px",
    background: "#EAEBFF",
    transition:'0.3s all'
  };
  const styleScrollTabSelect = {
    borderRadius: "19px",
    background: "#126E83",
    width: "16px",
    height: "8px",
    transition:'0.3s all'
  };
  return (
    <Box
      display="grid"
      justifyItems="center"
      alignItems="center"
      px="40px"
      height="75%"
      {...props}
    >
      <Box>
        <img src={image} />
      </Box>
      {value&&<Box display={"flex"} sx={{transition:'0.5s all'}} gap="6px">
        <Box sx={value===3?styleScrollTabSelect :styleScrollTab}></Box>
        <Box sx={value===2?styleScrollTabSelect :styleScrollTab}></Box>
        <Box sx={value===1?styleScrollTabSelect :styleScrollTab}></Box>
      </Box>}
      <Box textAlign={"right"}>
        <Typography
          sx={{
            color: "#FFF",
            textAlign: "right",
            fontFamily: "Shabnam",
            fontSize: "25px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "normal",
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            color: "#FFF",
            textAlign: "right",
            fontFamily: "Shabnam",
            fontSize: "25px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "normal",
          }}
        >
          {text}
        </Typography>
      </Box>
    </Box>
  );
}
